module.exports = __webpack_public_path__ + "media/images/city/040-pyramid-of-the-magician-bfb417007dfabf4f4c8e378f37fc1cc4.svg";